module.exports = {"421381001":"应山街道","421381002":"十里街道","421381003":"广水街道","421381004":"城郊街道","421381100":"武胜关镇","421381101":"杨寨镇","421381102":"陈巷镇","421381103":"长岭镇","421381104":"马坪镇","421381105":"关庙镇","421381106":"余店镇","421381107":"吴店镇","421381108":"郝店镇","421381109":"蔡河镇","421381110":"李店镇","421381111":"太平镇","421381112":"骆店镇","421381400":"中华山林场","421381401":"三潭风景区","421381402":"工业基地"}


//////////////////
// WEBPACK FOOTER
// ./src/town/421381.json
// module id = 1791
// module chunks = 0